import { SectionWithListPageSchema } from 'cms/schemaTypes/staticPages/documents/sectionList'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import FormattedText from 'shared/ui/FormattedText'

import { SectionContainer, SectionTitle } from '../landings/styles'

import styles from './HowToRegisterAfterSection.module.scss'

interface HowToRegisterAfterSectionProps {
  content: SectionWithListPageSchema
}

const HowToRegisterAfterSection = ({
  content
}: HowToRegisterAfterSectionProps) => {
  return (
    <SectionContainer $condensed className={styles.sectionContainer}>
      <section className={styles.contentWrapper}>
        <SectionTitle className={styles.sectionTitle}>
          <FormattedText text={content.header} />
        </SectionTitle>
        <ol className={styles.stepsWrapper}>
          {content.sectionList.map((step, i) => (
            <li key={step.key} className={styles.step}>
              <div className={styles.stepHeader}>
                <span className={styles.stepNumber}>{i + 1}</span>
                <span className={styles.stepTitle}>
                  <FormattedText text={step.header} />
                </span>
              </div>
              <div className={styles.stepContent}>
                <CustomPortableText value={step.content || []} />
              </div>
            </li>
          ))}
        </ol>
      </section>
    </SectionContainer>
  )
}

export default HowToRegisterAfterSection
